import { http, methods } from './config';

export const getCheckout = params => {
  const config = {
    method: methods.get,
    url: `/api/checkout`,
    params,
  };
  return http(config);
};